/// <reference types="vite/types/importMeta.d.ts" />
import * as z from "zod";

function loadEnvVar<T>(name: string, schema: z.ZodType<T>): T {
  try {
    let value: string | undefined;

    if (typeof process !== "undefined" && process.env) {
      value = process.env[name];
    }

    if (typeof import.meta !== "undefined" && import.meta.env) {
      value = import.meta.env[name];
    }

    return schema.parse(value);
  } catch (error) {
    if (error instanceof z.ZodError) {
      const errorMessage = error.issues
        .map((err) => {
          return `\t - ${name}: ${err.message}`;
        })
        .join("\n");

      throw Error(`Environment validation failed:\n${errorMessage}`);
    }
    throw error;
  }
}

export const AppConfig = {
  API_URL: loadEnvVar(
    "VITE_API_URL",
    z.url({
      protocol: /https|http/,
    }),
  ),
  WS_URL: loadEnvVar(
    "VITE_WS_URL",
    z.url({
      protocol: /wss|ws/,
    }),
  ),
  STRIPE_PUBLISHABLE_KEY: loadEnvVar(
    "VITE_STRIPE_PUBLISHABLE_KEY",
    z.string().startsWith("pk_"),
  ),
  GOOGLE_AUTH_CLIENT_ID: loadEnvVar("VITE_GOOGLE_AUTH_CLIENT_ID", z.string()),
  GOOGLE_ANALYTICS_CLIENT_ID: loadEnvVar(
    "VITE_GOOGLE_ANALYTICS_CLIENT_ID",
    z.string(),
  ),
  SENTRY: {
    DSN: loadEnvVar("VITE_SENTRY_DSN", z.string().optional()),
    ENVIRONMENT: loadEnvVar("VITE_SENTRY_ENVIRONMENT", z.string().optional()),
  },
  INTERCOM_APP_ID: loadEnvVar("VITE_INTERCOM_APP_ID", z.string().optional()),
  REDITUS: {
    URL: loadEnvVar("VITE_REDITUS_URL", z.string().optional()),
    UID: loadEnvVar("VITE_REDITUS_UID", z.string().optional()),
  },
  SEGMENT_WRITE_KEY: loadEnvVar(
    "VITE_SEGMENT_WRITE_KEY",
    z.string().optional(),
  ),
  HUBSPOT_PORTAL_ID: loadEnvVar(
    "VITE_HUBSPOT_PORTAL_ID",
    z.string().regex(/^\d+$/).optional(),
  ),
  IS_DEV:
    typeof import.meta !== "undefined" && import.meta.env
      ? Boolean(import.meta.env.DEV)
      : false,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(globalThis as any).AppConfig = AppConfig;
